import { Item } from '@/types/common';

export const useSort = () => {
  const startsWithEmoji = (str: string) => {
    // https://stackoverflow.com/a/41164587/1827654
    return /^\p{Emoji}/u.test(str);
  };

  const sortAlphabetically = (items: Item[], propertyForSort: CallableFunction | string) => {
    const itemsToSort = [...items];

    return itemsToSort.sort((a: Item, b: Item) => {
      let aName: string;
      let bName: string;
      if (a !== Object(a)) {
        aName = a as unknown as string;
        bName = b as unknown as string;
      } else if (typeof propertyForSort === 'function') {
        aName = propertyForSort(a);
        bName = propertyForSort(b);
      } else {
        aName = (a as never)[propertyForSort] ?? a;
        bName = (b as never)[propertyForSort] ?? b;
      }

      aName = aName?.toString() ?? '';
      bName = bName?.toString() ?? '';

      const aEmoji = startsWithEmoji(aName);
      const bEmoji = startsWithEmoji(bName);

      if (aEmoji && !bEmoji) return 1;
      if (!aEmoji && bEmoji) return -1;

      return aName.localeCompare(bName, undefined, { numeric: true, sensitivity: 'base' });
    });
  };

  return {
    sortAlphabetically,
  };
};
